import { useRouter } from 'next/router'

import { useAppSelector } from '~/redux/hooks'

import { LevelActionType } from '../types/bootcamp.types'
import { selectBootcampPageChest } from '../slices/bootcamp-page.slice'

function useShowFunFactChest(): boolean {
  const { query } = useRouter()
  const isQuizPage = query?.action === LevelActionType.Quiz
  const isActivityPage = query?.action === LevelActionType.Activity

  const chest = useAppSelector(selectBootcampPageChest)
  const showFunFactChest = !isQuizPage && !isActivityPage && chest && chest?.funfact

  return !!showFunFactChest
}

export default useShowFunFactChest
